
  import { Component, Vue ,Inject} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import UploadImg from '@/components/upload-img.vue';
  @Component({  
    name: '',
    components: {
      PageFooter,
      UploadImg
    }
  })

  export default class ProductList extends Vue {
    private token:any = {}
    @Inject() editinfo:any
    get editmsg(){
      return this.editinfo.msg
    }

    private uploadSuc(list){
      this.editinfo.msg.share = list[0]
    }
  }
